import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  specialOrders: [],
  error: null,
};

const orderKey = (order) => order?.orderId ?? order?.id;

export default function specialDeliveryReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SPECIAL_DELIVERY_INTAKE_SUCCESS: {
      const incoming = Array.isArray(payload) ? payload : [payload];
      return {
        ...state,
        specialOrders: [...state.specialOrders, ...incoming],
        error: null,
      };
    }
    case ActionTypes.SPECIAL_DELIVERY_INTAKE_FAILURE:
      return {
        ...state,
        error: payload,
      };
    case ActionTypes.SPECIAL_DELIVERY_ASSIGN_SUCCESS: {
      const assignedIds = payload?.orderIds ?? payload?.assignedOrderIds ?? [];
      return {
        ...state,
        specialOrders: assignedIds.length
          ? state.specialOrders.filter(
              (order) => !assignedIds.includes(orderKey(order))
            )
          : state.specialOrders,
        error: null,
      };
    }
    case ActionTypes.SPECIAL_DELIVERY_ASSIGN_FAILURE:
      return {
        ...state,
        error: payload,
      };
    case ActionTypes.CLEAR_SPECIAL_DELIVERY:
      return {
        ...state,
        specialOrders: [],
        error: null,
      };
    default:
      return state;
  }
}
